import React, { useState } from 'react';
import { AppBroadcastEvents, ModalsKeys } from 'global';
import { useSelector } from 'react-redux';
import { useModal } from 'hooks/useModal';
import { Button, Tooltip } from '@mui/material';
import { CustomDialog } from 'components/shared/Dialog';
import { useAppBroadcastPublisher } from 'hooks/useAppBroadcastPublisher';

import { useUserAdditionalAccounts } from '../api';
import { ListOfAdditionalAccounts } from './ListOfAdditionalAccounts';

export const SwitchAccountDialog = () => {
  const { handleClose, isOpen } = useModal(ModalsKeys.SwitchAccountDialog);
  const { handlePublishEvent } = useAppBroadcastPublisher();

  const currentAccountId = useSelector<any, string>(state => state.account.id);

  const [selectedRelation, setSelectedRelation] = useState<string | null>(null);

  const { isAccountSwitching, handleSwitchAccount } = useUserAdditionalAccounts();

  const onSwitchAccount = async () => {
    if (!selectedRelation) return;
    await handleSwitchAccount(selectedRelation);
    handleClose();
    handlePublishEvent(AppBroadcastEvents.PAGE_RELOAD);
    window.location.href = '/';
  };

  return (
    <CustomDialog
      isOpen={isOpen}
      onClose={handleClose}
      label="Switch Account"
      actions={
        <Tooltip title={!selectedRelation ? 'Select account' : ''}>
          <span>
            <Button
              variant="contained"
              onClick={onSwitchAccount}
              loading={isAccountSwitching}
              disabled={!selectedRelation}
            >
              Switch
            </Button>
          </span>
        </Tooltip>
      }
    >
      <ListOfAdditionalAccounts
        onChose={setSelectedRelation}
        selectedRelation={selectedRelation}
        currentAccountId={currentAccountId}
      />
    </CustomDialog>
  );
};
